export const ValidationCons = {
    IS_EMAIL: 'Please enter a valid email address',
    EMAIL_REQUIRED: 'Email address is required',
    PASSWORD_CASE: 'Your password needs to be at least 8 characters.',
    PASSWORD_REQUIRED:'Password field is Required',
    CONFIRM_PASSWORD_REQUIRED:'Confirm Password field is Required',
    PASSWORD_VALID:'Please enter valid password',
    PASSWORD_MATCH: 'Password must be at least 8 characters long, contain at least one uppercase letter, one numeric value, and one special character',
    FIRST_NAME_REQUIRED: 'First Name is Required',
    LAST_NAME_REQUIRED: 'Last Name is Required',
    PASSWORD_MISMATCH: 'Password and Confirm password not matching',
    OTP_VERIFY: 'Please enter 6 digit OTP Code',
    COMPANY_REQUIRED:'Please enter Company Name',
    COMPANY_LOGO:'Please attach Company Logo',
    AGENCY_REQUIRED:'Please enter Agency Name',
    AGENCY_LOGO:'Please attach Agency Logo',
    REGISTRATION_SUCCESS:'Registration Successful ! Please login',
    VALID_NAME: 'Please enter your name',
    VALID_PHONE: 'Please enter valid phone number',
    ABOUT_REQUIRED:'Please enter something about you',
    COUNTRY_NAME_REQUIRED: 'Country is Required',
    STATE_NAME_REQUIRED: 'State is Required',
    CITY_NAME_REQUIRED: 'City is Required',
    STREET_NAME_REQUIRED: 'Address is Required',
    ZIPCODE_REQUIRED: 'Pin code is Required',
    EDU_FROM_REQUIRED:  'Start Date is Required',
    EDU_TO_REQUIRED: 'End Date is Required',
    EDU_STREAM_REQUIRED: 'Field of Study is Required',
    EDU_SCHOOL_REQUIRED: 'School/College Name is Required',
    JOBROLE_REQUIRED: 'Job Role is Required',
    RESPONSIBITY_REQUIRED: 'Responsibility is Required',
    SKILL_REQUIRED: 'Skill is Required',
    SERVICEIN_REQUIRED: 'Service in language is Required',
    VISAREQUESTED_REQUIRED: 'Visa requested type is Required',
    FULLNAME_REQUIRED: 'Full name is Required',
    SEX_REQUIRED: 'Sex is Required',
    DATEOFBIRTH_REQUIRED: 'Date of Birth is Required',
    // PLACEOFBIRTH_REQUIRED: 'Place of birth is Required',
    COUNTRYORTERRITORY_REQUIRED: 'Country or Territory is Required',
    CITIZENSHIP_REQUIRED: 'Citizenship is Required',
    CURRENTCOUNTRY_REQUIRED: 'Current Country or Territory of residence is Required',
    CITIZENSTATUS_REQUIRED: 'Status is Required',
    PREVIOUSTERRITORYDIFFERENT_REQUIRED: 'This field is Required',
    MARITIALSTATUS_REQUIRED: 'Current marital status  is Required',
    SPOUSENAME_REQUIRED: 'Spouse / Common-Iaw partner name is Required',
    PREVIOUSLYMARRIED_REQUIRED: 'This field is Required',
    PREVIOUSSPOUSENAME_REQUIRED: 'This field is Required',
    PREVIOUSSPOUSEDOB_REQUIRED: 'Spouse Date of Birth is Required',
    TYPEOFRELATIONSHIP_REQUIRED: 'Relationship type is Required',
    PREVIOUSSPOUSEFROM_REQUIRED: 'From Date is Required',
    PREVIOUSSPOUSEFROM_LESSER_REQUIRED:`Previous spouse 'From' date must be after Date of Birth`,
    PREVIOUSSPOUSETILL_REQUIRED: 'To Date is Required',
    PREVIOUSSPOUSETILL_GREATERFROM_REQUIRED: `Previous spouse 'Till' date must be after 'From' date`,
    LANGUAGES_REQUIRED: 'Native language/Mother Tongue is Required',
    COMMUNICATIONFRENCH_REQUIRED: 'This field is Required',
    ASSESSPROFICIENCY_REQUIRED: 'This field is Required',
    PASSPORTNUMBER_REQUIRED: 'Passport number is Required',
    INVALID_PASSPORTNUMBER_FORMAT:'Invalid Passport number',
    COUNTRYOFPASSPORTISSUED_REQUIRED: 'This field is Required',
    ISSUEDATE_REQUIRED: 'Issue Date is Required',
    EXPIRYDATE_REQUIRED: 'Expiry Date is Required',
    EXPIRYDATE_GREATER_REQUIRED: `Expiry date must be greater than 'ISSUE DATE'`,
    NATIONALDOCUMENTNUMBER_REQUIRED: 'Document Number is Required',
    NATIONALDOCUMENTISSUER_REQUIRED: 'This field is Required',
    NATIONALDOCUMENTISSUEDATE_REQUIRED: 'Issue date is Required',
    NATIONALDOCUMENTEXPIRYDATE_REQUIRED: 'Expiry date is Required',
    GREENCARD_REQUIRED: 'This field is Required',
    GREENCARDNUMBER_REQUIRED: 'Green Card Number is Required',
    GREENCARDEXPIRY_REQUIRED: 'Expiry date is Required',
    CONTACTSTREET_REQUIRED: 'Street Name is Required',
    CONTACTCITY_REQUIRED: 'City/Town is Required',
    CONTACTCOUNTRY_REQUIRED: 'Country / Territory is Required',
    RESIDENTIALADDRESSSAME_REQUIRED: 'Residential address is Required',
    RESIDENTIALSTREET_REQUIRED: 'Street name is Required',
    RESIDENTIALCITY_REQUIRED: 'City/Town is Required',
    RESIDENTIALCOUNTRY_REQUIRED: 'Country / Territory is Required',
    // TELEPHONE_REQUIRED: 'Telephone no is Required',
    CONTACTTYPE_REQUIRED: 'Type is Required',
    // CONTACTCOUNTRYCODE_REQUIRED: 'This field is Required',
    // CONTACTNUMBER_REQUIRED: 'This field is Required',
    // CONTACTFAX_REQUIRED: 'This field is Required',
    CONTACTTYPE2_REQUIRED: 'Type is Required',
    // CONTACTCOUNTRYCODE2_REQUIRED: ' is Required',
    // CONTACTNUMBER2_REQUIRED: ' is Required',
    // CONTACTEMAIL_REQUIRED: ' is Required',
    CANADAVISITPURPOSE_REQUIRED: 'Purpose of visit is Required',
    CANADAVISITEDFROM_REQUIRED: 'From date is Required',
    CANADAVISITEDTILL_REQUIRED: 'To date is Required',
    // FUNDSAVAILABLECAD_REQUIRED: 'This field is Required',
    // NAMEINCANADA_REQUIRED: 'This field is Required',
    // ADDRESSINCANADA_REQUIRED: 'This field is Required',
    EDUCATIONSECONDARY_REQUIRED: 'Has any post secondary education',
    EDUCATIONSTARTEDYEAR_REQUIRED: 'From Year is Required',
    EDUCATIONSTARTEDMONTH_REQUIRED: 'From Month is Required',
    EDUCATIONTILLYEAR_REQUIRED: 'To Year is Required',
    EDUCATIONTILLMONTH_REQUIRED: 'To Month is Required',
    FIELDOFSTUDENT_REQUIRED: 'Field of Student is Required',
    SCHOOLNAME_REQUIRED: 'School / Facility name is Required',
    SCHOOLCITY_REQUIRED: 'City / Town is Required',
    SCHOOLCOUNTRY_REQUIRED: 'Country / Territory is Required',
    EMPLOYMENTFROMYEAR_REQUIRED: 'From Year is Required',
    EMPLOYMENTFROMMONTH_REQUIRED: 'From Month is Required',
    EMPLOYMENTTOYEAR_REQUIRED: 'From Year is Required',
    EMPLOYMENTTOMONTH_REQUIRED: 'From Month is Required',
    CURRENTOCCUPATION_REQUIRED: 'This field is Required',
    CURRENTCOMPANYNAME_REQUIRED: 'This field is Required',
    CURRENTCOMPANYCITY_REQUIRED: 'City / Town is Required',
    CURRENTCOMPANYCOUNTRY_REQUIRED: 'Country / Territory is Required',
    // TBINLAST2YEARS_REQUIRED: 'This field is Required',
    // PHYSICALMENTALDISORDER_REQUIRED: 'This field is Required',
    NAMEOFFAMILYMEMBER_REQUIRED: 'This field is Required',
    // WITHOUTAUTHORIZATION_REQUIRED: 'This field is Required',
    // VISADENIED_REQUIRED: 'This field is Required',
    // PREVIOUSLYAPPLIED_REQUIRED: 'This field is Required',
    YES2ABCDETIALS_REQUIRED: 'This field is Required',
    // CRIMINALOFFENCE_REQUIRED: 'This field is Required',
    CRIMINALDETAILS_REQUIRED: 'This field is Required',
    // MILITARYVOLUNTARY_REQUIRED: 'This field is Required',
    DETAILSVOLUNTARYSERVED_REQUIRED: 'This field is Required',
    // ASSOCIATEDWITHPOLITICALPARTY_REQUIRED: 'This field is Required',
    // WITNESSEDCIVILIANS_REQUIRED: 'This field is Required',
    REQUEST_IMMIGRATION_DUPLICATE: 'You have already submitted an immigration request. You will be notified of any status updates.',
    REQUEST_IMMIGRATION_APPROVED: 'Your immigration request has been approved.',
    REQUEST_IMMIGRATION_REJECTED: 'Your immigration request has been rejected.',

    REQUEST_IMMIGRATION_SUBMIT:'Your immigration request has been successfully submitted. It is now awaiting approval',
    PHONE_REQUIRED: 'Phone no is Required',
    MESSAGE: 'Message is Required',
  };
  